<template>
  <div id="user-area" class="level">
      <ul v-click-outside="hide" style="position:absolute; bottom:4px">
        <li class="ham-tab-ico">
          <a><i class="fa" :class="show?'fa-times':'fa-bars'" @click="show?hide():show=true"/></a>
        </li>
        <!-- <li v-for="(tab, index) in tabs" :key="index" :class="($route.name == tab.routerName ? 'active-tab ':'non-active-tab ') + (show?'':'hide-tabs')">
          <a :href="'/' + tab.router" >
            <icon icoClass='tab-ico' :selected='tab.ico'/>
            <span>{{$ml.get(tab.name)}}</span>
          </a>
        </li> -->
        <li class="non-active-tab" :class="show?'':'hide-tabs'" style="position:relative">
          <a @click="showUserConfig=!showUserConfig" >
            <i class='tab-ico fas fa-cog'/>
            <span>User Config</span>
          </a>
          <span id="buttons" v-if="showUserConfig">
              <button :class="{'select': (lan === 'en')}" class="lang l-left" @click="changeLanguage('en')">EN</button><!--
              --><button :class="{'select': (lan === 'es')}" class="lang l-right" @click="changeLanguage('es')">ES</button>
              <button class="is-small btn-black" @click="logout()">Log Out</button>
            <button class="is-small btn-black" style="height: 3em; line-height: 1em" @click="showChangePass=true">{{$ml.get('change_pass')}}</button>

            <modal-company v-if="showChangeCompany" @close="showChangeCompany=false"/>

            <!-- <modal v-if="showChangePass">
              <div slot="body">
                  <h2>{{$ml.get('change_pass')}}</h2>
                  <input type="password" placeholder="Old password" class="input modal-input" v-model="old_password">
                  <input type="password" placeholder="New password" class="input modal-input" v-model="new_password1">
                  <input type="password" placeholder="Repite new password" class="input modal-input" v-model="new_password2">
                  <div style="text-align:center; padding-top:.8em">
                    <button class="btn-blue" @click="changePassword()">{{$ml.get('save')}}</button>
                    <button class="btn-black" @click="showChangePass=false">{{$ml.get('cancel')}}</button>
                  </div>
              </div>
            </modal> -->
          </span>
        </li>
      </ul>
  </div>
</template>

<script>
/*
import Modal from '@/components/Modal' */
export default {
  name: 'user-area',
  props: ['user'],
  data () {
    return {
      /* tabs: [{name: 'dashboard', ico: 'dashboard', router: 'dashboard', routerName: 'dashboard'},
        {name: 'trucks', ico: 'trucks', routerName: 'trucks', router: 'trucks'},
        {name: 'expeditions', ico: 'expeditions', routerName: 'expeditions', router: 'expeditions'},
        {name: 'receptions', ico: 'receptions', router: 'receptions', routerName: 'receptions'},
        {name: 'bi', ico: 'bi', router: 'bi', routerName: 'bi'}
        {name: 'import', ico: 'import', router: 'import', routerName: 'import'},
        {name: 'export', ico: 'export', router: 'export', routerName: 'export'} ], */
      show: false,
      showUserConfig: false,
      old_password: '',
      new_password1: '',
      new_password2: '',
      lan: '',
      showChangePass: false,
      showChangeCompany: false
    }
  },
  mounted () {
    this.lan = localStorage.getItem('vueml-lang')
  },
  computed: {
    test () {
      return this.$route.name
    }
  },
  components: {},
  methods: {
    changeLanguage (lg) {
      localStorage.setItem('vueml-lang', lg)
      this.$ml.change(lg)
      this.lan = lg
    },
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login')
      })
    },
    changePassword () {
      if (this.new_password1 === this.new_password2) {
        this.$store.dispatch('auth/changePassword', {
          old_password: this.old_password,
          // new_password1: this.new_password1,
          new_password: this.new_password1
        }).then(() => {
          this.clearFields()
          this.showChangePass = false
        })
      } else {
        this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$ml.get('pass_different') })
      }
    },
    cancelation () {
      this.clearFields()
    },
    clearFields () {
      this.old_password = ''
      this.new_password1 = ''
      this.new_password2 = ''
    },
    hide () {
      this.show = false
      this.showUserConfig = false
    }
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          console.warn(warn)
        }
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },
      unbind: function (el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
.modal-input{
  margin-top: 10px
}
.button{
  font-weight: bold;
}
button {
  margin: .1em;
}
#buttons{
  padding: 3px 0;
  display: block;
  position: absolute;
  width: 10em;
  right: 0;
  text-align: right;
  .is-small{
    width: 100%;
  }
  .lang{
    width: 49%;
  }
}
input[type="password"]{
  display: block;
  margin-left: auto;
  margin-right: auto;
}
h2 {
  text-transform: uppercase;
  color: #009D97;
}
.lang{
  font-family: MuseoSans-500;
  background: $k-lime;
  border: none;
  font-size: .9em;
  padding: .2em .9em;
  cursor: pointer;
  &:hover {
    font-weight: bolder;
    background-color: $k-lime-text;
  }
}
.l-left {
  border-top-left-radius: .2em;
  border-bottom-left-radius: .2em;
  margin-right: 0;
}
.l-right {
  border-top-right-radius: .2em;
  border-bottom-right-radius: .2em;
  margin-left: 0;
}
.select{
  font-family: MuseoSans-900;
  box-shadow: inset 0px 0px 5px 2px rgba($color: $k-turq, $alpha: .2);
}

</style>



// WEBPACK FOOTER //
// src/components/UserArea.vue